import { apiClient } from "@/lib/apiClient";

export const billingService = {
  async subscription() { return (await apiClient.get("/billing/subscription")).data.subscription; },
  async plans() { return (await apiClient.get("/billing/plans")).data; },
  async foundingStatus() { return (await apiClient.get("/billing/founding-status")).data; },
  async checkout(plan_code) { return (await apiClient.post("/billing/checkout", { plan_code, origin_url: window.location.origin })).data; },
  async portal() { return (await apiClient.post("/billing/portal", { origin_url: window.location.origin })).data; },
  async cancel() { return (await apiClient.post("/billing/cancel")).data.subscription; },
  async reactivate() { return (await apiClient.post("/billing/reactivate")).data.subscription; },
};

export const STATUS_LABELS = {
  none: "No subscription", incomplete: "Incomplete", trialing: "Free trial", active: "Active",
  past_due: "Payment past due", grace_period: "Grace period", cancel_at_period_end: "Cancels at period end",
  cancelled: "Cancelled", expired: "Expired", suspended: "Suspended", complimentary: "Complimentary",
};
